import React from 'react';
import { useParams } from 'react-router-dom';

// ── Import the hook we just added to useLeads.js ──────────────────────────────
// useLeadHistory(leadId) hits  GET /api/lead/history/:projectId
// and returns the standard react-query shape:
//   { data, isLoading, isError, error }
// where data = { projectId, history: [ { timestamp, performedByName, action, ... } ] }
import { useLeadHistory } from '../hooks/useLeads';

function LeadHistory() {
  // leadId comes from the URL param set in LeadsDetails — no need to prop-drill
  const { leadId } = useParams();

  const { data, isLoading, isError, error } = useLeadHistory(leadId);

  // ── Loading state ─────────────────────────────────────────────────────────
  if (isLoading) return <div>Loading...</div>;

  // ── Error state ───────────────────────────────────────────────────────────
  if (isError) {
    return (
      <div>
        <p>Error: {error.message}</p>
        <p>Status: {error.response?.status}</p>
      </div>
    );
  }

  // ── data.history is the array from  GET /api/lead/history/:projectId
  //    Each item: { timestamp, performedByName, action, details: { ... } }
  const history = data?.history ?? [];

  return (
    <div
      className="container-fluid p-3"
      style={{
        backgroundColor: '#F9FAFB',
        borderRadius: 10,
        color: '#000',
        overflowY: 'auto',
        maxHeight: '68vh',
      }}
    >
      <h3>History</h3>

      {history.length > 0 ? (
        history.map((item, index) => {
          // Format the ISO timestamp into a readable string
          const formattedDate = new Date(item.timestamp).toLocaleString('en-US', {
            year:   'numeric',
            month:  'long',
            day:    'numeric',
            hour:   '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
          });

          return (
            <p key={index}>
              {formattedDate}
              &nbsp;|&nbsp;
              {item.performedByName}
              &nbsp;|&nbsp;
              {/* item.taskName doesn't exist in your history schema —
                  the server stores  details.leadName  instead */}
              {item.details?.leadName ?? item.taskName}
              &nbsp;|&nbsp;
              {item.action}
            </p>
          );
        })
      ) : (
        <p>No history available</p>
      )}
    </div>
  );
}

export default LeadHistory;